// extracted by mini-css-extract-plugin
module.exports = {"component":"styles_component__b5xRr","menu":"styles_menu__wxYlR","space":"styles_space__P8gHV"};